module.exports = __webpack_public_path__ + "static/img/prod-book.ced1a0b4.svg";